export default __webpack_public_path__ + "static/media/more-elipsis-icon.de4b4ebe.svg";